import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getApiUrl } from '../config/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // For Google OAuth, we need to call an endpoint to get the token in the response body
    // For now, redirect to Equity Intelligence dashboard after auth
    navigate('/equity-intelligence', { replace: true });
  }, [navigate]);

  return (
    <div
      className="min-h-[70vh] flex items-center justify-center"
      data-testid="auth-callback"
    >
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-2 border-[#C8A84B] border-t-transparent rounded-full animate-spin" />
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-slate-500">
          Signing you in…
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
